import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import Link from 'next/link'

type Props = {
  imagePath: string
  name: string
  id: number
  slug?: string
}

export const PopularProgramCardImage = ({
  imagePath,
  name,
  id,
  slug,
}: Props): JSX.Element => {
  const getTransitionDetailPath = (targetPath: string) => {
    if (slug) {
      targetPath += `?selected_program=${slug}`
    }
    return targetPath
  }

  return (
    <div className="w-full lg:w-[32.6vw] h-[42.7vw] lg:h-full lg:hover:opacity-50">
      <Link href={getTransitionDetailPath(`/programs/${id}`)}>
        <a>
          <ImageWraper
            className="rounded-bl-[20px]"
            src={imagePath}
            width={920}
            height={450}
            alt={`${name}のイメージ画像`}
          />
        </a>
      </Link>
    </div>
  )
}
